var _path, _path2, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessLocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 91,
    viewBox: "0 0 109 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8889 31.561V24.0864L39.4093 1.76025L0.92981 24.0539V31.5285C0.92981 54.5047 13.1306 75.7259 32.9691 87.2302L39.4093 90.9675L45.8496 87.2302C65.688 75.7584 77.8889 54.5372 77.8889 31.561Z",
    fill: "#F8B400",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1228 46.6296C18.1228 41.1705 22.5482 36.7451 28.0073 36.7451H50.4121C55.8711 36.7451 60.2965 41.1705 60.2965 46.6296V63.1037C60.2965 68.5627 55.8711 72.9882 50.4121 72.9882H28.0073C22.5482 72.9882 18.1228 68.5627 18.1228 63.1037V46.6296Z",
    stroke: "#028789",
    strokeWidth: 1.97689
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1866 55.8409C42.3755 55.0798 43.1635 53.7474 43.1635 52.231C43.1635 49.8654 41.2458 47.9478 38.8802 47.9478C36.5146 47.9478 34.5969 49.8654 34.5969 52.231C34.5969 53.7475 35.385 55.0798 36.5739 55.841V60.7974C36.5739 62.0712 37.6065 63.1038 38.8802 63.1038C40.154 63.1038 41.1866 62.0712 41.1866 60.7974V55.8409Z",
    fill: "#028789"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0073 37.4046V29.497C28.0073 23.6741 32.7278 18.9536 38.5508 18.9536V18.9536C44.3737 18.9536 49.0942 23.6741 49.0942 29.497V35.9157",
    stroke: "#028789",
    strokeWidth: 1.97689
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.2573,
    cy: 23.0465,
    r: 22.924,
    fill: "#049E26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9766 24.2749L80.345 32.0527L97.538 14.041",
    stroke: "white",
    strokeWidth: 4.09357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLocker);
export default __webpack_public_path__ + "static/media/successLocker.3a3e3561f53f4d552884c99244267829.svg";
export { ForwardRef as ReactComponent };